import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  buttonProgress: {
    color: '#ffffff',
  },
}));

const Loader = ({history}) => {
  const classes = useStyles({})
  return (
    <CircularProgress size={20} className={classes.buttonProgress}/>
  );
};

// @ts-ignore
export default Loader
